// Re-export ticker config from centralized source
const {
    STOCKS_WITH_SECTORS,
    STOCK_LIST,
    TICKER_TO_NAME,
    SECTORS,
    getCompanyName,
    getSectorForTicker,
    getTickersForSector
} = require("../config/tickers")

const alertConfig = {
    STRONG_BUY: {
        color: "bg-green-500",
        label: "Strong Buy"
    },
    BUY: {
        color: "bg-green-700",
        label: "Buy"
    },
    SELL: {
        color: "bg-red-500",
        label: "Sell"
    },
    STRONG_SELL: {
        color: "bg-red-700",
        label: "Strong Sell"
    },
    params: [
        {
            label: "Daily",
            color: "bg-orange-500"
        },
        {
            label: "Momentum (Past 30 Days)",
            color: "bg-blue-500"
        },
        {
            label: "Momentum (Past 90 Days)",
            color: "bg-cyan-700"
        }
    ]
}

const marketStatusItems = [
    {
        label: "All",
        value: "all"
    },
    {
        label: "Market",
        value: "on"
    },
    {
        label: "Off Market",
        value: "off"
    }
]

const alertTypes = [
    {
        label: "Sentiment",
        value: "PRICE",
        superText: "+"
    },
    {
        label: "Sentiment",
        value: "SENTIMENT"
    }
]

const dashboardViews = [
    {
        label: "Stock",
        value: "STOCK"
    },
    {
        label: "Sector",
        value: "SECTOR"
    }
]

const SINGLE_GRAPH_DURATION = ["1D", "7D", "14D", "30D", "60D", "90D"]

export {
    alertConfig,
    marketStatusItems,
    alertTypes,
    dashboardViews,
    STOCKS_WITH_SECTORS,
    STOCK_LIST,
    TICKER_TO_NAME,
    SECTORS,
    getCompanyName,
    getSectorForTicker,
    getTickersForSector,
    SINGLE_GRAPH_DURATION
}
